import { render, staticRenderFns } from "./PageSperrgebieteExport.vue?vue&type=template&id=2bb755ab&scoped=true&"
import script from "./PageSperrgebieteExport.vue?vue&type=script&lang=js&"
export * from "./PageSperrgebieteExport.vue?vue&type=script&lang=js&"
import style0 from "./PageSperrgebieteExport.vue?vue&type=style&index=0&id=2bb755ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb755ab",
  null
  
)

export default component.exports